import { push } from "connected-react-router";
import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { fetchResourceItem } from "../../redux/actions/learningCenter/resourcesActions";
import ResourceViewer from "./ResourceViewer";

const ResourceViewerContainer = ({
  match: {
    params: { sectionId, itemId }
  },
  currentItem,
  LayoutComponent,
  loading,
  fetchResourceItem
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    fetchResourceItem(sectionId, itemId);
  }, [itemId]);

  const handleExitToResources = exitLink => {
    dispatch(push(exitLink));
  };

  if (
    !loading &&
    currentItem &&
    typeof currentItem === "object" &&
    Object.keys(currentItem).length > 0
  ) {
    return (
      <ResourceViewer
        {...currentItem}
        LayoutComponent={LayoutComponent}
        onExit={handleExitToResources}
      />
    );
  } else {
    return "";
  }
};

const mapStateToProps = state => ({
  currentItem: state.resourcesState.currentResourceItem,
  loading: state.resourcesState.loading,
  error: state.resourcesState.error
});

export default connect(mapStateToProps, { fetchResourceItem })(
  ResourceViewerContainer
);
